import React, { Component } from "react";
import { getPlayStoreUrl } from "../../utils/playStoreUrl";
// import axios from 'axios';
import jsonData from "../../db.json";
//const BASE_URL = "https://my-json-server.typicode.com/themeland/json-server-1/themeOneFooterSection";

class FooterSection extends Component {
  state = {
    data: jsonData.themeOneFooterSection,
    iconList: jsonData.themeOneFooterSection.iconList,
    footerList_1: jsonData.themeOneFooterSection.footerList_1,
    footerList_2: jsonData.themeOneFooterSection.footerList_2,
    footerList_3: jsonData.themeOneFooterSection.footerList_3,
  };

  render() {
    const playStoreUrl = getPlayStoreUrl("footer");
    return (
      <div>
        <div className="height-emulator d-none d-lg-block" />
        <footer className="footer-area footer-fixed">
          {/* Footer Top */}
          <div className="footer-top ptb_100">
            <div className="container">
              <div className="row">
                <div className="col-12 col-sm-6 col-lg-5">
                  {/* Footer Items */}
                  <div className="footer-items">
                    {/* Logo */}
                    <a className="navbar-brand" href="/#">
                      <img
                        className="logo"
                        src={this.state.data.image}
                        alt=""
                      />
                    </a>
                    <p className="mt-2 mb-3">
                      MoneyMonk is a digital lending platform owned and operated
                      by Monk Capital Private Limited, an RBI Registered
                      Non-Banking Financial Company (NBFC), Regn No. N-09.00457.
                      Registered Office: The Platina, B-406, Sy No. 132, 134, H.
                      No. 4-50/1, Gachibowli, K.V. Rangareddy, Serilingampally,
                      Hyderabad, Telangana – 500032. For more details, please
                      visit{" "}
                      <a href={"https://www.monkcapital.in"}>
                        www.monkcapital.in
                      </a>
                    </p>
                    {/* Social Icons */}
                    <div className="social-icons d-flex">
                      {this.state.iconList.map((item, idx) => {
                        return (
                          <a
                            key={`fi_${idx}`}
                            className={item.link}
                            href={item.url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className={item.iconClass} />
                            <i className={item.iconClass} />
                          </a>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-lg-2">
                  {/* Footer Items */}
                  <div className="footer-items">
                    {/* Footer Title */}
                    <h3 className="footer-title mb-2">
                      {this.state.data.linkText_1}
                    </h3>
                    <ul>
                      {this.state.footerList_1.map((item, idx) => {
                        return (
                          <li key={`flo_${idx}`} className="py-2">
                            <a href="/#">{item.text}</a>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-lg-3">
                  {/* Footer Items */}
                  <div className="footer-items">
                    {/* Footer Title */}
                    <h3 className="footer-title mb-2">
                      {this.state.data.linkText_2}
                    </h3>
                    <ul>
                      {this.state.footerList_2.map((item, idx) => {
                        return (
                          <li key={`flt_${idx}`} className="py-2">
                            <a href={item.link}>{item.text}</a>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-lg-2">
                  {/* Footer Items */}
                  <div className="footer-items">
                    {/* Footer Title */}
                    <h3 className="footer-title mb-2">
                      {this.state.data.linkText_3}
                    </h3>
                    {/* Store Buttons */}
                    <div className="button-group store-buttons store-black d-flex flex-wrap">
                      {this.state.footerList_3.map((item, idx) => {
                        return (
                          <a
                            key={`flth_${idx}`}
                            href={playStoreUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img src={item.image} alt="" />
                          </a>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Footer Bottom */}
          <div className="footer-bottom">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {/* Copyright Area */}
                  <div className="copyright-area d-flex flex-wrap justify-content-center justify-content-sm-center text-center py-4">
                    {/* Copyright Left */}
                    <div className="copyright-left">
                      © Copyrights 2026 MONK CAPITAL PRIVATE LIMITED All rights
                      reserved.
                    </div>
                    {/* Copyright Right */}
                    {/* <div className="copyright-right">Made with <i className="fas fa-heart" /> By <a href="/#">Themeland</a></div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default FooterSection;
